<div class="page">
  <app-page-header page-title="deadlines.privacySagSubscriptionsList.pageTitle"></app-page-header>
  <div class="page-content">

    <div class="row mb-4">
      <div class="col-12">
        <button class="navigation-button navigation-button-active" mat-flat-button routerLinkActive="navigation-button-active"
          routerLink="/{{ lang }}/app/deadlines/list/privacy-sag-subscriptions">
          {{ 'deadlines.navigation.btnPrivacySag' | translate }}
        </button>

        <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
          routerLink="/{{ lang }}/app/deadlines/list/privacy-subscriptions">
          {{ 'deadlines.navigation.btnPrivacy' | translate }}
        </button>
      </div>
    </div>

    <mat-card class="custom-card">
      <mat-card-title>{{ 'deadlines.privacySagSubscriptionsList.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportDeadlines')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                  <button mat-raised-button (click)="onRenewDeadlines()" color="primary" *ngIf="roleAdmin">
                    <mat-icon fontSet="fal" fontIcon="fa-repeat"></mat-icon>
                    {{ 'deadlines.fields.renew' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="endDatePrivacy"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="master">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'deadlines.fields.master' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../../companies/detail/{{ element._id}}">
                      {{ element.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="masterFilter" [matAutocomplete]="masterAuto">
                      <mat-autocomplete autoActiveFirstOption #masterAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onMasterFilterSelected($event)">
                        <mat-option *ngIf="masterIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!masterIsLoading">
                          <mat-option *ngFor="let master of availableMasters" [value]="master"
                            (onSelectionChange)="onMasterFilterSelected($event)">
                            <small>{{ master.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(masterFilter)"
                        class="reset-input-icon" *ngIf="masterFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="endDatePrivacy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'deadlines.fields.date' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.subscription.endDatePrivacy | dateFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="endDatePrivacyFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(endDatePrivacyFilter)"
                        class="reset-input-icon" *ngIf="endDatePrivacyFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="propertiesNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'deadlines.fields.propertiesNumber' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.propertiesNumber }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertiesNumberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertiesNumberFilter)"
                        class="reset-input-icon" *ngIf="propertiesNumberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                    {{ 'deadlines.fields.price' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.subscription.privacyFee }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="priceFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(priceFilter)"
                        class="reset-input-icon" *ngIf="priceFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions" class="col-fixed-xs">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'deadlines.fields.downloadProperties' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <button mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}"
                      (click)="onDownloadProperties(element)">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                  </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="renew">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'deadlines.privacySagSubscriptionsList.renew' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <mat-checkbox [checked]="element.checked"
                      (change)="onSubsSelected(element, $event.checked)" class="checkbox-insert">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->
